<template>
    <div class="service-qrcode-box" id="service-qrcode-box">
        <!-- <title-nav v-if="$store.state.userAgent === 'Mobile'" :title="'客服微信'" /> -->
        <title-nav :title="'客服微信'" />
        <div class="content">
            <img src="../../assets/images/customer-service.jpg" alt="" width="100%">
            <div class="tips">长按识别添加客服</div>
        </div>
    </div>
</template>

<script>
import TitleNav from '../../components/nav/TitleNav.vue'

export default {
  name: 'ServiceQrcode',
  components: {
    TitleNav
  },
  mounted(){

  },
  data(){
      return {
      }
  },
  methods:{

  },
  props:{

  }
}
</script>

<style scoped lang="scss">
.service-qrcode-box {
    background: #fff;
    min-height: calc(100vh - 60px);
    box-sizing: border-box;
    .content {
        margin: 50px 20px 10px;
        padding-top: 15px;
        div {
            padding:5px 0;
        }
        .title {
            text-align: left;
            font-size: 22px;
        }
        .answer {
            text-align: left;
            color: rgba(0,0,0,0.5)
        }
        .tips {
            color: #969699;
        }
    }
}
</style>
